import { ApplicationRef, Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable } from 'rxjs';
import { formErrorPipe } from './form-error-pipe';

@Injectable()
export class FormErrorService {
  errors$: BehaviorSubject<any> = new BehaviorSubject<any>([]);

  constructor(private application: ApplicationRef) {}

  public errorsFor(property: string): Observable<string[]> {
    return this.errors$.pipe(formErrorPipe(property));
  }

  public onError(response): Observable<never> {
    this.errors$.next(response.error.message);
    this.application.tick();

    return EMPTY;
  }

  public onSuccess() {
    this.errors$.next([]);
  }
}
